import { ApiUrlBuilder } from "@shared/util/api-url-builder";

const AUTH = ApiUrlBuilder.defaultFor('AUTH_API_URL')

export const PUBLIC_URLS = [
    `${AUTH}/login`,
    `${AUTH}/send-reset-password`,
]